import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';

const httpLink = createHttpLink({
  uri: (process.env.NEXT_PUBLIC_WORDPRESS_URL || 'https://blog.partnersinplumbing.com') + '/graphql',
  credentials: 'same-origin',
  // Safari-compatible fetch options
  fetchOptions: {
    timeout: 15000, // Increased timeout for Safari compatibility
    signal: typeof AbortController !== 'undefined' ? undefined : null, // Safari compatibility
  },
});

export const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache({
    typePolicies: {
      RootQuery: {
        queryType: true,
      },
      RootMutation: {
        mutationType: true,
      },
    },
    resultCaching: true,
    addTypename: true,
  }),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'ignore',
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
      notifyOnNetworkStatusChange: false,
    },
    query: {
      errorPolicy: 'all',
      fetchPolicy: 'cache-first',
      notifyOnNetworkStatusChange: false,
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
  queryDeduplication: true,
  ssrMode: typeof window === 'undefined',
  assumeImmutableResults: true,
});

export default client; 